<template>
  <div class="welcome-view">
    <div class="welcome-content">
      <i class="fas fa-comments welcome-icon"></i>
      <h2>Добро пожаловать в WondaCRM</h2>
      <p>Выберите чат из списка слева, чтобы начать общение</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WelcomeView'
};
</script>

<style scoped>
.welcome-view {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  background-color: #f5f5f5;
}

.welcome-content {
  text-align: center;
  padding: 30px;
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.welcome-icon {
  font-size: 48px;
  color: #2196f3;
  margin-bottom: 20px;
}

h2 {
  margin-bottom: 15px;
  color: #333;
}

p {
  color: #707579;
}
</style> 